import { render } from "./LogoCertificata.vue?vue&type=template&id=e4b69f26&scoped=true&ts=true"
import script from "./LogoCertificata.vue?vue&type=script&lang=ts"
export * from "./LogoCertificata.vue?vue&type=script&lang=ts"

import "./LogoCertificata.vue?vue&type=style&index=0&id=e4b69f26&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b69f26"]])

export default __exports__